import { render } from "./dialogAddItem.vue?vue&type=template&id=4750a7c8&scoped=true"
import script from "./dialogAddItem.vue?vue&type=script&lang=js"
export * from "./dialogAddItem.vue?vue&type=script&lang=js"

import "./dialogAddItem.vue?vue&type=style&index=0&id=4750a7c8&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4750a7c8"]])

export default __exports__